/**
 * Local copy of the page url rules from `sanitisePageUrl` in @quizee/events.
 *
 * It is duplicated rather than imported because that module lives behind a zod backed barrel, and
 * pulling zod into the embed would cost more than the whole bundle budget. The rules are pinned by
 * a test that runs both implementations over the same inputs.
 */

const MAX_URL = 2048;
const MAX_HOST = 255;

/** Strip query string, fragment and credentials. Returns an empty string rather than throwing. */
export function sanitisePageUrl(input: string): string {
  let url: URL;
  try {
    url = new URL(input);
  } catch {
    return '';
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';

  url.search = '';
  url.hash = '';
  url.username = '';
  url.password = '';

  const out = url.toString();
  return out.length > MAX_URL ? out.slice(0, MAX_URL) : out;
}

/**
 * Host only. A full referrer routinely carries search terms and newsletter recipient identifiers,
 * which is personal data we have no business holding.
 */
export function referrerHost(input: string): string | undefined {
  if (!input) return undefined;
  let url: URL;
  try {
    url = new URL(input);
  } catch {
    return undefined;
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;
  const host = url.hostname;
  if (!host || host.length > MAX_HOST) return undefined;
  return host;
}
